<template>
    <v-dialog v-model="visible" max-width="400px">
        <v-card>
            <v-card-title class="headline">Confirm Action</v-card-title>
            <v-card-text>
                <p>Are you sure you want to disable this user?</p>
                <v-list dense>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title><strong>Username:</strong> {{ user.username }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title><strong>Email:</strong> {{ user.email }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title><strong>First Name:</strong> {{ user.first_name }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title><strong>Surname:</strong> {{ user.surname }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            <v-list-item-title><strong>Role:</strong> {{ user.user_role_desc }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="cancel">Cancel</v-btn>
                <v-btn color="error" @click="confirm">Disable</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        visible: Boolean,
        user: Object
    },
    methods: {
        cancel() {
            this.$emit('close');
        },
        confirm() {
            this.$emit('confirm');
        }
    }
}
</script>
